module.exports = __webpack_public_path__ + "assets/img/894e7c205d2c9e45fef0c19295ce616a.png";